'use client';

import { useEffect, useRef, useState } from 'react';

/**
 * Gère la barre de progression et l'auto-fermeture après `durationMs`.
 */
export const useAutoCloseProgress = ({
  isOpen,
  durationMs,
  onClose,
}: {
  isOpen: boolean;
  durationMs: number;
  onClose: () => void;
}) => {
  const [elapsed, setElapsed] = useState(0);
  const openedAtRef = useRef(0);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    openedAtRef.current = Date.now();

    const tick = setInterval(() => {
      const diff = Date.now() - openedAtRef.current;
      setElapsed(Math.min(diff, durationMs));

      if (diff >= durationMs) {
        clearInterval(tick);
        onClose();
      }
    }, 50);

    return () => clearInterval(tick);
  }, [isOpen, durationMs]);

  const progressValue =
    durationMs > 0 ? Math.min(100, (elapsed / durationMs) * 100) : 0;

  return { progressValue };
};
